import * as fleetVehiclesServices from './fleetVehiclesServices';

export { fleetVehiclesServices };
